export default (props: { color?: string }) => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M16.333 2.333H7a2.34 2.34 0 0 0-2.333 2.334v18.666A2.34 2.34 0 0 0 7 25.668h14a2.34 2.34 0 0 0 2.333-2.334v-14l-7-7zm1.167 10.5h-4.667V14h3.5a1.17 1.17 0 0 1 1.167 1.167v3.5a1.17 1.17 0 0 1-1.167 1.166h-1.166V21h-2.334v-1.166H10.5V17.5h4.667v-1.166h-3.5a1.17 1.17 0 0 1-1.167-1.167v-3.5a1.17 1.17 0 0 1 1.167-1.167h1.166V9.334h2.334V10.5H17.5v2.334z"
			fill={props.color || "#367BF5"}
		/>
	</svg>
);
